export default __webpack_public_path__ + "static/10_23-a79c379218c125d0ba068795fbd23203.png";